module.exports = __webpack_public_path__ + "img/ai_chat.b18169fa.png";